module.exports = __webpack_public_path__ + "static/05-015b5bc9282a934ce9e181f5d5998620.png";